import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=1d916e79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d916e79"]])

export default __exports__